import { GatewayApi } from './base';
import { toBase64, Constructor } from '../common';

class StatisticsImpl {
    constructor(
        readonly process_time?: string,
        readonly sic?: string,
        readonly objectId?: string,
        readonly source?: string,
        readonly content_type?: string,
        readonly processing_type?: string,
        readonly res?: string,
        readonly json_output?: string,
    ) {}
}

export interface StatisticsEvent extends StatisticsImpl { }

export type StatisticsField = keyof StatisticsEvent;
export type StatisticsFilter = {field: StatisticsField, operator: string, value: any}[];

export const statisticsFields: StatisticsField[] =
    Object.keys(new StatisticsImpl()) as StatisticsField[];

export class StatisticsApi extends GatewayApi {
    constructor() {
        super('statistics');
    }

    index(
        filter?: Record<string, any>,
        page: number = 1,
        page_size: number = 10,
        ): Promise<{ items: StatisticsEvent[], count: number }> {
        return this.invoke('index', { filter, page, page_size });
    }
}
